import VisualPlannerApi from "@/VisualPlannerApi";

export default {
  namespaced: true,

  state: {
    persons: [],
    subjects: [],
    courses: [],
    shortevents: [],
    educationalCourses: [],
    isLoading: false
  },

  mutations: {
    SET_PERSON_LIST(state, list) {
      state.persons = list;
    },
    SET_SUBJECT_LIST(state, list) {
      state.subjects = list.subjects;
      state.courses = list.courses;
      state.shortevents = list.short_events;
      state.educationalCourses = list.educational_courses;
    },
    SET_LOADING(state, loading) {
      state.isLoading = loading;
    }
  },

  actions: {
    async fetchSelectionValues({ commit }) {
      commit('SET_LOADING', true);
      try {
        await Promise.all([
          //TODO() Fetch people, rooms, articles and events
          VisualPlannerApi.get('/selection-values/person')
            .then((response) => {
              commit('SET_PERSON_LIST', response.data);
            }),
          VisualPlannerApi.get('/selection-values/subject')
            .then((response) => {
              commit('SET_SUBJECT_LIST', response.data);
            })
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        commit('SET_LOADING', false);
      }
    }
  },

  getters: {
    getPersonList: state => state.persons,
    getIsLoading: state => state.isLoading
  }
};
